import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="relative z-20 w-full bg-black/80 backdrop-blur-sm border-t border-white/10 py-4">
      <div className="text-center text-gray-200 text-sm">
        © {new Date().getFullYear()}{" "}
        <span className="font-semibold text-white">Mediiq</span> • Avec{" "}
        <span className="text-pink-400">❤️</span> par{" "}
        <a
          href="https://www.loven-soft.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-pink-400 font-semibold hover:underline"
        >
          LSD
        </a>
      </div>
    </footer>
  );
};

export default Footer;
